import * as React from 'react';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { Flex } from '@stoplight/mosaic';


export interface ICaret {
  isExpanded: boolean;
}

export const Caret: React.FunctionComponent<ICaret> = ({ isExpanded }) => (
  <Flex pl={3} w={8} ml={-8} color="muted" role="button" justifyContent="center">
    {/* <Icon size={CARET_ICON_SIZE} fixedWidth icon={isExpanded ? 'chevron-down' : 'chevron-right'} /> */}
    {isExpanded ? (
      <ExpandMoreIcon style={{ width: '1em', height: '1em' }} />
    ) : (
      <ChevronRightIcon style={{ width: '1em', height: '1em' }} />
    )}
  </Flex>
);
